export const productData = {
  title: '产品',
  subtitle: 'product',
  path: '/product',
  products: [
    {
      title: '健康管理',
      icon:
        'https://img.alicdn.com/tfs/TB1H2BUyrj1gK0jSZFOXXc7GpXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1pGLfyeT2gK0jSZFvXXXnFXXa-768-1092.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '通过健康信息采集、检测、评估、干预等手段，来预防和控制疾病的发生与发展。',
    },
    {
      title: '患者360全息视图',
      icon:
        'https://img.alicdn.com/tfs/TB1gDxQyrr1gK0jSZR0XXbP8XXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB17ErhykL0gK0jSZFAXXcA9pXa-768-1092.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '展示患者全量医疗数据的同时，患者画像和自定专科视图让数据的展示变得更灵活，更高效。',
    },
    {
      title: '智能导诊',
      icon:
        'https://img.alicdn.com/tfs/TB1R_FLyqL7gK0jSZFBXXXZZpXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1DlziykY2gK0jSZFgXXc5OFXa-768-1092.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc: '基于AI导诊模型，根据患者的病情描述为其推荐合适的就诊科室。',
    },
    {
      title: '医院智慧管理平台',
      icon:
        'https://img.alicdn.com/tfs/TB1EHXUyAT2gK0jSZPcXXcKkpXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB17ErhykL0gK0jSZFAXXcA9pXa-768-1092.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '通过现代化数仓技术，搭配专业和先进医院管理团队经验。实现医院管理数据可视化，运营专题预测分析等',
    },
    {
      title: '诊前助手',
      icon:
        'https://img.alicdn.com/tfs/TB1evJUyrY1gK0jSZTEXXXDQVXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1WmHkybj1gK0jSZFOXXc7GpXa-724-1026.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc: '就诊前的预问诊，提高医生诊断效率与质量。',
    },
    {
      title: '用药助手',
      icon:
        'https://img.alicdn.com/tfs/TB1M5VTyxv1gK0jSZFFXXb0sXXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1ga_fyeT2gK0jSZFvXXXnFXXa-768-1092.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '用药提醒与用药记录的功能，提醒用户按时服药，整合院内院外用药记录并给予智能化的合理用药提醒。',
    },
    {
      title: '闭环管理',
      icon:
        'https://img.alicdn.com/tfs/TB1WMdHy9f2gK0jSZFPXXXsopXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1N.pIy7L0gK0jSZFxXXXWHVXa-768-1094.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '监控业务闭环数据，洞察业务流程缺陷，为业务流程改造、优化提供数据决策支持。',
    },
    {
      title: '态势感知平台',
      icon:
        'https://img.alicdn.com/tfs/TB1vOVKyYj1gK0jSZFOXXc7GpXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1JIFMyYj1gK0jSZFuXXcrHpXa-768-1094.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '基于先进的医疗大数据平台，形成医疗指标体系，以图表，多维分析视图，可视化大屏形式展现，形成医疗数据展示分析态势感知平台。',
    },
    {
      title: '基础服务平台',
      icon:
        'https://img.alicdn.com/tfs/TB15uRLyW61gK0jSZFlXXXDKFXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1WDlHy1H2gK0jSZFEXXcqMpXa-768-1094.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '通过统一的数据标准、精细的主数据管理、唯一的患者标识、一站式的业务监管、丰富的权限管理等功能，为医疗机构提供数据建设的基础服务平台',
    },
    {
      title: '数据质量管理平台',
      icon:
        'https://img.alicdn.com/tfs/TB19KtFy.z1gK0jSZLeXXb9kVXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB1nZXFy.z1gK0jSZLeXXb9kVXa-768-1094.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '用于解决各种数据质量问题，全面提升数据的完整性、规范性、一致性等，降低数据管理成本，提高数据利用率。',
    },
    {
      title: '服务管理平台',
      icon:
        'https://img.alicdn.com/tfs/TB1I6hKyYY1gK0jSZTEXXXDQVXa-230-230.png',
      img:
        'https://img.alicdn.com/tfs/TB14MRKyYY1gK0jSZTEXXXDQVXa-768-1094.png',
      coverImg:
        'https://img.alicdn.com/tfs/TB1lM_mybj1gK0jSZFuXXcrHpXa-768-1092.png',
      desc:
        '将服务进行统一接入、统一管理、统一调度，实现异构系统之间的解耦，促进服务的集中监管，保证数据服务的安全。',
    },
  ],
};
